export enum Medium {
  'electricity' = 'electricity',
  'water' = 'water',
  'gas' = 'gas',
  'waste' = 'waste',
  'heat' = 'heat',
}
